// src/i18n/locales/en/admin.ts
// English translations for admin panel

export default {
  login: {
    title: 'Admin Portal',
    subtitle: 'Secure access for administrators only',
    adminBadge: 'ADMIN',
    userLogin: 'User Login',
    email: 'Admin Email',
    emailPlaceholder: 'admin@nutribot.com',
    password: 'Admin Password',
    passwordPlaceholder: 'Enter your admin password',
    loginButton: 'Secure Admin Login',
    signingIn: 'Signing in...',
    warning: 'This is a restricted area. All access attempts are logged and monitored.',
    features: {
      secure: 'Encrypted',
      monitoring: '24/7 Monitoring',
      control: 'Full Control',
    },
    errors: {
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email format',
      passwordRequired: 'Password is required',
      passwordTooShort: 'Password must be at least 6 characters',
      invalidCredentials: 'Invalid email or password',
      notAdmin: 'Access denied. Admin privileges required.',
      loginFailed: 'Login failed. Please try again.',
      unknownError: 'An unknown error occurred',
    },
    success: 'Admin login successful',
  },
  layout: {
    title: 'Admin Dashboard',
    logoAdmin: 'Admin',
    logoPanel: 'Panel',
    subtitle: 'NutriBot Management',
    badgeTitle: 'Administrator',
    badgeSubtitle: 'Full System Access',
    adminBadge: 'ADMIN',
    menu: {
      dashboard: 'Dashboard',
      users: 'Users',
      analytics: 'Analytics',
      plans: 'Meal Plans',
      influencers: 'Influencer Codes',
      affiliates: 'Affiliates',
      discounts: 'Retail Discounts',
      settings: 'Settings',
    },
    userMenu: {
      profile: 'Admin Profile',
      settings: 'System Settings',
      logout: 'Logout',
    },
  },
  dashboard: {
    title: 'System Overview',
    stats: {
      totalUsers: 'Total Users',
      totalRevenue: 'Total Revenue',
      activePlans: 'Active Plans',
      vipBasicRatio: 'VIP/BASIC Ratio',
    },
    charts: {
      userGrowth: 'User Growth',
      userGrowthSubtitle: 'VIP vs BASIC users over time',
      planDistribution: 'Plan Distribution',
      refresh: 'Refresh',
    },
  },
  users: {
    title: 'User Management',
    subtitle: 'Manage all users and subscriptions',
    search: 'Search users...',
    newUser: 'New User',
    refresh: 'Refresh',
    loading: 'Loading users...',
    stats: {
      totalUsers: 'Total Users',
      vipUsers: 'VIP Users',
      basicUsers: 'BASIC Users',
      activeUsers: 'Active Users',
      ofTotal: 'of total',
      completedOnboarding: 'Completed onboarding',
    },
    filters: {
      all: 'All Plans',
      vip: 'VIP Only',
      basic: 'BASIC Only',
      allStatus: 'All Status',
      active: 'Active',
      inactive: 'Pending',
    },
    status: {
      active: 'Active',
      pending: 'Pending',
    },
    table: {
      name: 'Name',
      email: 'Email',
      plan: 'Plan',
      status: 'Status',
      joined: 'Joined',
      actions: 'Actions',
      empty: 'No users found',
    },
    actions: {
      edit: 'Edit',
      view: 'View Details',
      suspend: 'Suspend',
      delete: 'Delete',
    },
    bulk: {
      selected: '{{count}} selected',
      upgradeVIP: 'Upgrade to VIP',
      downgradeBasic: 'Downgrade to BASIC',
      delete: 'Delete',
      clearSelection: 'Clear selection',
      confirmUpgrade: 'Upgrade {{count}} users to VIP?',
      confirmDowngrade: 'Downgrade {{count}} users to BASIC?',
      confirmDelete: 'Delete {{count}} users permanently?',
      planUpdated: '{{count}} users updated successfully',
      deleted: '{{count}} users deleted successfully',
    },
    pagination: {
      showing: 'Showing {{start}}-{{end}} of {{total}} users',
    },
    errors: {
      fetchFailed: 'Failed to load users',
      bulkUpdateFailed: 'Bulk update failed',
      bulkDeleteFailed: 'Bulk delete failed',
    },
    confirmDelete: 'Delete {{name}} permanently?',
    confirmSuspend: 'Suspend {{name}}?',
  },
  modals: {
    userDetails: {
      title: 'User Details',
      tabs: {
        profile: 'Profile',
        plan: 'Nutrition Plan',
        progress: 'Progress',
        payments: 'Payments',
      },
    },
    editUser: {
      title: 'Edit User',
      subtitle: 'Update user information',
      fields: {
        name: 'Name',
        email: 'Email',
        plan: 'Plan',
        status: 'Status',
        role: 'Role',
      },
      save: 'Save Changes',
      cancel: 'Cancel',
    },
    inviteUser: {
      title: 'Invite New User',
      subtitle: 'Send invitation email to new user',
      fields: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        plan: 'Assign Plan',
      },
      send: 'Send Invitation',
      cancel: 'Cancel',
    },
    otp: {
      title: 'Verify Action',
      subtitle: 'Enter your authentication code',
      placeholder: 'Enter 6-digit code',
      verify: 'Verify',
      cancel: 'Cancel',
      resend: 'Resend Code',
    },
  },
  otp: {
    codeSent: 'Verification code sent to your email',
    invalidCodeLength: 'Please enter a 6-digit code',
    verificationSuccess: 'Verification successful',
    invalidCode: 'Invalid verification code',
    verificationFailed: 'Verification failed',
    actionWarning: 'You are about to {{action}} user: {{targetName}}',
  },
};